import { Link } from "react-router-dom";  
import estilos from "./ItemCard.module.css";  

function ItemCard(props) {
    return (
        // O Link redireciona o usuário para a página específica do personagem com base no ID fornecido nos dados
        <Link to={`/personagem/${props.dados.id}`} className={estilos.card}> 
            <img src={props.dados.image} alt={`Imagem do personagem ${props.dados.name}`} />  
            <h1>{props.dados.name}</h1>  
            <p>{props.dados.race} - {props.dados.gender}</p>  
        </Link>
    );
}

export default ItemCard;
